<template>
  <button
    type="button"
    class="button"
    :style="{ maxWidth: maxWidth + 'px' }"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'CustomBtn',

  props: {
    maxWidth: {
      type: [String, Number],
      default: 260,
    },
  },
};
</script>

<style lang="sass" scoped>
.button
  background: #F98B25
  border-radius: 4px
  font-size: 18px
  font-weight: 500
  line-height: 24px
  padding: 12px
  color: #fff
  width: 100%
  border: 0
  transition: background .25s
  &:hover
    background: #FFBC57
</style>